import axios from "axios";

export const API = {
     get(url, data) {
        let
            tokenEl = document.querySelector('[name="csrf-token"]')
            , csrftoken = tokenEl ? tokenEl.getAttribute('content') : ''
            , header = {}
        header['X-CSRF-Token'] = csrftoken
        return axios({
            method: 'POST',
            url: url,
            headers: header,
            // decompress:false,
            data: data
        }, {
            withCredentials: true
        })
    },
    catch(err) {
        if (err.response) {
            // client received an error response (5xx, 4xx)
            console.error("Server Error:", err)
        } else if (err.request) {
            // client never received a response, or request never left
            console.error("Network Error:", err)
        } else {
            console.error("Client Error:", err)
        }
    }
}
